import env from "react-dotenv";
export const CONFIG_DEV = {
    ACCOUNT_MANAGEMENT_HOST: process.env.REACT_APP_URL_PSEP_BE, // Server Production
    // ACCOUNT_MANAGEMENT_HOST: "https://psep-be-account.eduprime.co.id", // Server Production
    //  ACCOUNT_MANAGEMENT_HOST: "http://45.64.97.198:8010", // Server Stagging
    //ACCOUNT_MANAGEMENT_HOST: 'http://localhost:8010', // Server Localhost
    // ACCOUNT_MANAGEMENT_HOST: "http://192.168.0.200:8010", // Server Localhost-Ardi
    // ACCOUNT_MANAGEMENT_HOST: "http://13.251.196.184:8010", // Server Riku

    ACCOUNT_MANAGEMENT_LOGIN: "/account/login",
    ACCOUNT_MANAGEMENT_COOKIES_CHECK: "/account/cekCookies",
    ACCOUNT_MANAGEMENT_LOGOUT: "/account/logOut",
    ACCOUNT_MANAGEMENT_HOME: "/account/home",
    ACCOUNT_MANAGEMENT_UPDATE_PROFIL: "/account/update",
    ACCOUNT_MANAGEMENT_UPLOAD_FOTO: "/account/uploadLogoSekolah",
    ACCOUNT_MANAGEMENT_FETCH_MENU: "/menu/menuByRole/",
    ACCOUNT_MANAGEMENT_SEARCH_KELAS: "/kelas/search",
    ACCOUNT_MANAGEMENT_GET_KELAS: "/kelas/listkelas",
    ACCOUNT_MANAGEMENT_GET_SEKOLAH: "/sekolah/get/",
    ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL: "kelas/kelasParalelSearch",
    ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN: "sekolah/getTa",

    ACCOUNT_MANAGEMENT_REGISTRASI_USER_SEKOLAH: "/sekolah/account",
    ACCOUNT_MANAGEMENT_GET_DETAIL_SEKOLAH: "/sekolah?id_sekolah=",
    ACCOUNT_MANAGEMENT_VERIFICATION_ACCOUNT: "/sekolah/account/verify-account?", // params => idSekolah=&token= || jika new password ada bodynya (usernameAdmin{current} & newPassword)

    ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_KELAS_PARALEL: "/siswa/getsiswa",
    ACCOUNT_MANAGEMENT_SEARCH_PAKET_PROGRAM_BY_KELAS_PARALEL: "/siswa/getPpByKp",
    ACCOUNT_MANAGEMENT_SEARCH_VOUCHER_BY_KELAS_PARALEL_PAKET_PROGRAM: "/siswa/fetchVoucherByKpAndPp",
    ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_USERNAME: "/siswa/getUsername/?username=",
    ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_ID_SISWA: "/siswa/getSiswaById/?idSiswa=",
    ACCOUNT_MANAGEMENT_RESET_PW_SISWA: "/siswa/resetPw",
    ACCOUNT_MANAGEMENT_GET_CBT_SISWA: "/siswa/getCbtSiswa/",
    ACCOUNT_MANAGEMENT_GET_CBT_MAPEL_SISWA: "/siswa/getMapelCbtSiswa/",
    ACCOUNT_MANAGEMENT_RESET_CBT_SISWA: "/siswa/resetCbt",
    ACCOUNT_MANAGEMENT_SISWA_IMPORT: "/siswa/import",
    ACCOUNT_MANAGEMENT_UPDATE_JENJANG: "/siswa/updateJenjang",

    ACCOUNT_MANAGEMENT_FETCH_GURU: "/guru/getGuru",
    ACCOUNT_MANAGEMENT_REGIS_GURU: "/guru/regisGuru",
    ACCOUNT_MANAGEMENT_UPDATE_GURU: "/guru/updateGuru",
    ACCOUNT_MANAGEMENT_RESET_PW_GURU: "/guru/resetPw",
    ACCOUNT_MANAGEMENT_HAPUS_GURU: "/guru/hapus",
    ACCOUNT_MANAGEMENT_SEARCH_GURU: "/guru/searchGuru",
    ACCOUNT_MANAGEMENT_SEARCH_GURU_BY_ID: "/guru/getGuruById",
    ACCOUNT_MANAGEMENT_CHANGE_STATUS_GURU: "/guru/changeStatus",
    ACCOUNT_MANAGEMENT_GURU_IMPORT: "guru/import",

    GET_KELAS_BY_GURU: "/guru/kelasByGuru?id=",
    GET_GURU_KELAS_BY_KP: "/guru/guruKelas?idKelasParalel=",

    GURU_GET_MAPEL_BY_KELAS: "/guru/getMapelByIdKelasAndIdGuru",
    GURU_GET_KELASPARALEL_BY_KELAS: "/guru/getKelasParalelGuruByIdKelas?idKelas=",

    ACCOUNT_MANAGEMENT_ADD_GURU_KELAS: "guru/saveGuruKelas",
    ACCOUNT_MANAGEMENT_FETCH_GURU_MAPEL: "/guru/fetchGuruMapel",
    ACCOUNT_MANAGEMENT_ADD_UP_GURUMAPEL: "/guru/addUpGuruMapel",
    ACCOUNT_MANAGEMENT_DELETE_GURUMAPEL: "/guru/delGuruMapel/?idDgm=",

    ACCOUNT_MANAGEMENT_GET_LIST_KELAS_PARAREL: "kelaspararel/get/",
    ACCOUNT_MANAGEMENT_CREATE_KELAS_PARAREL: "kelaspararel/simpan",
    ACCOUNT_MANAGEMENT_GET_BY_ID_KELAS_PARAREL: "kelaspararel/get/",
    ACCOUNT_MANAGEMENT_UPDATE_KELAS_PARAREL: "kelaspararel/update",
    ACCOUNT_MANAGEMENT_DELETE_KELAS_PARAREL: "kelaspararel/delete",

    MAPEL_MANAGEMENT_FETCH_MAPEL_BY_ID_KELAS: "/mapel/listmapel?idKelas=",
    MAPEL_MANAGEMENT_FETCH_TEMATIK_BY_ID_KELAS: "/mapel/listtema",
    MAPEL_MANAGEMENT_GET_BAB: "/mapel/getBab/",
    MAPEL_MANAGEMENT_GET_SUBBAB: "/mapel/getSubBab/",
    MAPEL_MANAGEMENT_LEARNING_GET_SUBBAB: "mapel/getSubBabLearning/",
    MAPEL_MANAGEMENT_GET_SUBBAB_SOAL: "/mapel/getSubBabSoal/",
    MAPEL_MANAGEMENT_GET_SUBTEMA: "/mapel/subtema",
    MAPEL_MANAGEMENT_GET_PEMBTEMA: "/mapel/pembtema",
    MAPEL_MANAGEMENT_GET_PEMBTEMA_SOAL: "/mapel/pembtemaSoal",

    SOAL_GET_UPLOAD_HISTORY: "/banksoal/getUploadHis",
    SOAL_FILTERSOAL: "/banksoal/filterSoal",
    SOAL_UPLOAD: "/banksoal/upload",
    SOAL_GET_BY_ID: "/banksoal/getSoalById?id=",
    SOAL_DELETE_BY_ID: "/banksoal/delete?id=",
    SOAL_EDIT_BY_ID: "/banksoal/edit",

    CBT_MANAGEMENT_HOST: "https://localhost:8013",
    CBT_MANAGEMENT_PROFIL_CBT_SEARCH: "/cbt/search",
    CBT_MANAGEMENT_PROFIL_OVERVIEW: "/cbt/overviewByProfil",
    CBT_MANAGEMENT_PROFIL_GET_BY_ID: "/cbt/getById",
    CBT_MANAGEMENT_PENCAPAIAN_INDIKATOR: "/cbt/pencapaianIndikator",
    // EXAM MODULE //
    EXAM_LIST: "/exam/listExam",
    EXAM_TAMBAH: "/exam/tambah",
    EXAM_DELETE: "/exam/delete",
    EXAM_GET_BY_ID: "/exam/getById",
    EXAM_UPDATE: "/exam/update",

    EXAM_ADD_MAPEL: "/exam/sub/add",
    EXAM_EDIT_MAPEL: "/exam/sub/edit",
    EXAM_DELETE_MAPEL: "/exam/sub/delete",
    EXAM_GET_SUBPROFIL_BY_ID: "/exam/getSubProfilById?id=",
    EXAM_SOAL_GET: "/exam/examSoal?id=",
    EXAM_ADD_SOAL: "/exam/addSoal",

    EXAM_JADWAL_LIST: "/exam/jadwal?id=",
    EXAM_GET_JADWAL_BY_ID: "/exam/getJadwalById?id=",
    EXAM_GET_JADWAL_PARALEL: "/exam/getJadwalParalel?idJadwal=",
    EXAM_GET_JADWAL_SISWA: "/exam/getJadwalSiswa?idJadwal=",
    EXAM_JADWAL_SAVE: "/exam/saveJadwal",
    EXAM_JADWAL_SUB_SAVE: "/exam/saveJadwalSub",
    EXAM_JADWAL_DELETE: "/exam/deleteJadwal?id=",
    EXAM_GET_JADWAL_SUB_PROFIL: "/exam/getJadwalSubProfil/",
    EXAM_GET_JADWAL_SEKOLAH: "/exam/getJadwalSekolah",
    EXAM_GET_JADWAL_BY_IDPROFIL: "/exam/getJadwalByIdProfil?id=",
    EXAM_KOREKSI_ESSAY: "/home-works/koreksiEssay",

    REKAP_EXAM: "/report/rekap_exam",
    REKAP_EXAM_DETAIL: "report/rekap_exam_detail",
    REKAP_EXAM_DETAIL_SISWA: "report/detailexamsiswa",

    // Homework
    HW_LIST: "/home-works",
    HW_GET_BY_ID: "/home-works/getById?id=",
    HW_ADD: "/home-works/add",
    HW_UPDATE: "/home-works/edit",
    HW_REPORT: "/home-works/report",
    HW_GET_PROFIL_GURU: "/home-works/profilHwGuru?idKelas=",
    HW_GET_JADWAL_PROFIL_GURU: "/home-works/jadwalProfilHwGuru?idProfilCbt=",
    HW_REPORT_BY_KP: "/report/kelashw",
    HW_REPORT_BY_DETAIL_JAWABAN: "/report/kelashwdetail",

    CBT_GET_ESSAY_SISWA: "/home-works/getEssaySiswa/",

    //Learning
    LEARNING_GET_LIST: "/learning/",
    LEARNING_GET_CONTENT: "/learning/content",
    LEARNING_GET_SOAL_PROFIL: "/learning/content/soal/",
    LEARNING_GET_TEKS_PROFIL: "/learning/content/materi/",
    LEARNING_GET_VIDEO_PROFIL: "/learning/content/video/",
    LEARNING_GET_LEARNINGSISWA: "/learning/learningsiswa/",
    LEARNING_RENC_BELAJAR_SEQ: "/learning/sequence",
    LEARNING_PEMB_LATIHAN_SEQ: "/learning/pemlat/sequence",
    LEARNING_POST_RENC_BELAJAR: "/learning/header/save",
    LEARNING_POST_EDIT_RENC_BELAJAR: "/learning/header/edit",
    LEARNING_DEL_RENC_BELAJAR: "/learning/header/delete/",
    LEARNING_POST_PEMB_LATIHAN: "/learning/pemlat/save",
    LEARNING_POST_EDIT_PEMB_LATIHAN: "/learning/pemlat/edit",
    LEARNING_DEL_PEMB_LATIHAN: "/learning/pemlat/delete/",
    LEARNING_POST_PROFIL_HUB: "/learning/profile/hub/save",
    LEARNING_GET_RENCBEL_KLS_PARALEL: "/learning/getRencBelKelasParalel/",
    LEARNING_GET_CONTENT_MATERI: "/learning/content/getMateri",

    // Report Dinas
    REPORT_DINAS_AGCU_PROFIL: "/dinas/profildinas/", // param1 = idProfilCbt
    REPORT_DINAS_AGCU_LIST: "/report/agcu_dinas",
    REPORT_DINAS_AGCU_NEW_LIST: "/report/agcu_dinas_new",
    REPORT_DINAS_LIVE: "/dinas/jadwalLiveReport",
    REPORT_DINAS_SNBT: "/dinas/reportSnbt",

    // Report CBT
    REPORT_CBT_GET_JADWAL: "/reportCbt/getJadwalCbt/",
    REPORT_CBT_GET: "/reportCbt/reportCbt",
    REPORT_CBT_SBMPTN: "/reportCbt/repotsbmptn",
    REPORT_CBT_REKAP_SBMPTN: "/reportCbt/rekapsbmptn",
    REPORT_REKOMENDASI_SBMPTN: "/reportCbt/rekomsbmptn",
    REPORT_REKOMENDASI_SNMPTN: "/snmptn/rekomendasiSiswa",
    REPORT_CBT_LOAD_INDIKATOR: "/reportCbt/getIndikator",
    REPORT_CBT_LIST_SISWA: "/reportCbt/listSiswa",
    REPORT_CBT_LIST_MONITORING_SISWA: "/reportCbt/indikator",
    GET_REPORT_AKM: "/reportCbt/reportakm/",
    REPORT_CBT_STA_LIST_SISWA: "/reportCbt/listSiswaTa",
    REPORT_CBT_STA_LIVE_LIST_SISWA: "/reportCbt/listSiswaTaLive",
    REPORT_CBT_STA_SEKOLAH: "/reportCbt/reportStaSekolah",

    //REKAPITULASI
    GET_JADWAL_CBT_TA: "/report/jadwalCbtTa",
    GET_REKAP_TA: "/report/rekapTalentAnalysis",

    // AKM DINAS
    GET_JENJANG_DINDIK: "/asmdinas/jenjangDinas",
    GET_PROFIL_CBT_DINDIK: "/asmdinas/cbtProfil",
    GET_PROFIL_CBT_DINDIK_ENSA: "/asmdinas/cbtProfilEnsa",
    GET_REPORT_ASM_DINAS: "asmdinas/report",
    FETCH_DETAIL_CBT_SISWA_BY_ID_JADWAL: "reportCbt/detailpengerjaanakademik/",

    // MIGRASI //
    MIGRASI_V1_KELAS: "/migrasi/kelas/",
    MIGRASI_V1_MAPEL: "/migrasi/mapel?idKelas=",
    MIGRASI_V1_KATEGORI: "/migrasi/kategoriBankSoal?idMapel=",
    MIGRASI_V1_SOALBYKATEGORI: "/migrasi/bankSoal?idKategori=",
    MIGRASI_V1_PROSES_MIGRASI: "/migrasi/prosesMigrasi",

    MIGRASI_V1_KURIKULUM: "/migrasi/kurikulum",
    MIGRASI_V1_BAB: "/migrasi/bab",
    MIGRASI_V1_SUB_BAB: "/migrasi/subBabByType",
    MIGRASI_V1_PINDAH_MATERI: "/migrasi/prosesMigrasiMateri",
    MIGRASI_V1_PINDAH_SOAL_LAT: "/migrasi/soalLatihan",

    CARI_SISWA_BY_USERNAME: "siswa/pengerjaanAll?username=",
    RESET_STATUS_PENGERJAAN: "siswa/resetPengerjaan?idSubHeader=",
    RESET_PROFIL_SISWA: "siswa/resetProfilSiswa?username=",
    CARI_DOUBLE_USERNAME: "siswa/doubleUsername?username=",
    PROSES_GANTI_USERNAME: "siswa/prosesGantiUsername?idsiswa=",
    GANTI_PASSWORD_MANUAL: "siswa/gantiPasswordManual",
    CHECK_PSEP_MERAH_SISWA_SELESAI: "siswa/checkReportMerah",

    // HISTORY ASSET SEKOLAH //
    FETCH_UPHIS_GURU_SEKOLAH: "aktivity/uphis",
    FETCH_HW_GURU_SEKOLAH: "aktivity/hwsekolah",
    FETCH_DETAIL_HW_GURU: "aktivity/detailpengerjaanhwguru",

    // COMPARASI
    COMPARASI_PAKET_PROGRAM_BY_KELAS_PARALEL: "report/ppkp?idKp=",
    FETCH_COMPARASI: "report/comparasi",

    // VIDEO CONFERENCE
    VC_JADWAL_LIST: "vidconf/listvc",
    VC_JADWAL_SAVE: "vidconf/addupdate",
    VC_JADWAL_DETAIL: "vidconf/detailvc?idJadwal=",
    VC_JADWAL_DELETE: "vidconf/delvc?idProfil=",

    // SNMPTN
    SNMPTN_FETCH_PTN: "snmptn/getPtnByProvinsi?idProvinsi=",
    SNMPTN_FETCH_PRODI: "snmptn/getProdiByPtn?idPtn=",
    SNMPTN_FETCH_SISWA_SEMESTER: "snmptn/siswasnmptn",
    SNMPTN_FETCH_FORM_NILAI: "snmptn/formnilaisiswa",
    SNMPTN_DODATA_RAPORT_SISWA: "snmptn/doDataRaport",
    SNMPTN_CHANGE_BUKA_TUTUP: "snmptn/doBukaTutup",
    SNMPTN_CHANGE_BUKA_TUTUP_REPORT: "snmptn/doBukaTutupReport",
    SNBP_GENERATE_EXCEL: "/snmptn/generate_excell_input_nilai",
    SNBP_IMPORT_NILAI: "/snmptn/import_nilai_siswa",

    GET_LIST_SEMESTER: "/snmptn/listSemester?idKelasParalel=",
    SET_SNMPTN: "/snmptn/setSemester",
    GET_LIST_MAPEL: "/snmptn/listMatapelajaran",
    SET_LIST_MAPEL: "/snmptn/setMatapelajaran",

    // PEMINATAN
    PEMINATAN_: "/peminatan/",
    PEMINATAN_REPORTING: "/peminatan/report",
    PEMINATAN_KECAKAPAN_UMUM_REPORTING: "/peminatan/ku?idheader=",
    PEMINATAN_JUMLAH_SISWA_KELAS: "/peminatan/jumsiskelas",
    PEMINATAN_DETAIL_KECAKAPAN_UMUM: "/peminatan/detailku?idjadwal=",

    // PEMETAAN
    REPORT_PEMETAAN_VALIDATE_COUNT_ALL_SISWA: "/pemetaan/validate_count_siswa",
    REPORT_PEMETAAN_COUNT_ALL_SISWA: "/pemetaan/count_all_siswa",
    REPORT_PEMETAAN_FETCH_LIST_PENGERJAAN_SISWA: "/pemetaan/list_status_pengerjaan_siswa",
    REPORT_PEMETAAN_PAGE_ONE: "/pemetaan/reportsekolah_pemetaan_matrikulasi",
    REPORT_PEMETAAN_PAGE_TWO: "/pemetaan/reportsekolah_merdeka_belajar",
    REPORT_PEMETAAN_PAGE_TWO_RIASEC: "/pemetaan/reportsekolah_riasec",
    REPORT_PEMETAAN_PAGE_THREE: "/pemetaan/reportsekolah_hasil_asessment_by_placement",
    REPORT_PEMETAAN_PAGE_FOUR: "/pemetaan/reportsekolah_survey_karakter_siswa",
    REPORT_PEMETAAN_PAGE_SEVEN: "/pemetaan/reportsekolah_tema_project",
    REPORT_PEMETAAN_PAGE_EIGHT: "/pemetaan/reportsekolah_belum_selesai_merdeka_belajar",
    REPORT_PEMETAAN_KU: "/pemetaan/ku?idSiswa=",

    // PEMETAAN 2
    REPORT_PEMETAAN2_PAGE_ONE: "/pemetaan2/reportsekolah_pemetaan_matrikulasi",
    REPORT_PEMETAAN2_VALIDATE_COUNT_ALL_SISWA: "/pemetaan2/validate_count_siswa",
    REPORT_PEMETAAN2_COUNT_ALL_SISWA: "/pemetaan2/count_all_siswa",
    REPORT_PEMETAAN2_PAGE_THREE: "/pemetaan2/reportsekolah_hasil_asessment_by_placement",
    REPORT_PEMETAAN_KU_SMK: "/pemetaan2/ku?idSiswa=",

    // PEMETAAN 3
    REPORT_PEMETAAN3_VALIDATE_COUNT_ALL_SISWA: "/pemetaan3/validate_count_siswa",
    REPORT_PEMETAAN3_COUNT_ALL_SISWA: "/pemetaan3/count_all_siswa",
    REPORT_PEMETAAN3_FETCH_LIST_PENGERJAAN_SISWA: "/pemetaan3/list_status_pengerjaan_siswa",
    REPORT_PEMETAAN3_PAGE_ONE: "/pemetaan3/dignostikkognitif",
    REPORT_PEMETAAN3_PAGE_TWO: "/pemetaan3/dignostiknonkognitif",
    REPORT_PEMETAAN3_PAGE_TWO_RIASEC: "/pemetaan3/reportsekolah_riasec",
    REPORT_PEMETAAN3_PAGE_THREE: "/pemetaan3/rekapmi",
    REPORT_PEMETAAN3_PAGE_FOUR: "/pemetaan3/reportsekolah_survey_karakter_siswa",
    REPORT_PEMETAAN3_PAGE_SEVEN: "/pemetaan3/reportsekolah_tema_project",
    REPORT_PEMETAAN3_PAGE_EIGHT: "/pemetaan3/reportsekolah_belum_selesai_merdeka_belajar",
    REPORT_PEMETAAN3_KU: "/pemetaan3/ku?idSiswa=",

    // END EXAM MODULE //
    SUCCESS_ERROR_CODE: "EP-000",
    ERROR_CODE_ENTITY_NOT_FOUND: "EP-001",
    INTERNAL_SERVER_ERROR_CODE: "EP-006",
    ID_ROLE_ADMIN_SEKOLAH: 9,
    ID_ROLE_GURU: 10,
};
